import { ISystemReportDto, ISystemReportGenerateDataDto } from 'src/generated-types/system-report-types'
import { queryClient } from 'src/query-client'
import { useGet, usePost } from '../reactQuery'

const baseUrl = () => 'system-reports'

export const endpoints = {
  getReports() {
    return `${baseUrl()}`
  },
  generateReports() {
    return `${baseUrl()}/generate-pdf`
  },
  generateExcelReport() {
    return `${baseUrl()}/generate-excel`
  },
  generateMooringAllComponentsReport(customerId: EntityId, localityId: EntityId, mooringId: EntityId) {
    return `customers/${customerId}/localities/${localityId}/moorings/${mooringId}/all-components-report`
  },
}

export const invalidateSystemReports = {
  getSystemReports() {
    queryClient.invalidateQueries(endpoints.getReports())
  },
}

export const useGetSystemReports = () => useGet<ISystemReportDto[]>(endpoints.getReports())

export const useGenerateSystemReports = () =>
  usePost<ISystemReportGenerateDataDto, object>(endpoints.generateReports(), {}, { responseType: 'arraybuffer' })

// "Alle komponenter" (PDF) limited to one mooring.
export const useGenerateMooringAllComponentsReport = (
  customerId: EntityId,
  localityId: EntityId,
  mooringId: EntityId,
) =>
  usePost<ArrayBuffer, object>(
    endpoints.generateMooringAllComponentsReport(customerId, localityId, mooringId),
    {},
    { responseType: 'arraybuffer' },
  )

export const useGenerateExcelReports = () =>
  usePost<ISystemReportGenerateDataDto, object>(endpoints.generateExcelReport(), {}, { responseType: 'arraybuffer' })
